import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {screenType} from '../../constants/analytics';
import {entityIssueScreen} from '../../utils/analytics-helpers';
import Loader from '@adsk/bim360-matrix-react-loader';
import Tabs from '@adsk/bim360-matrix-react-tabs';
import ProjectGrid from './ProjectGrid';
import TemplatesProjectGridContainer from '../templates/TemplatesProjectGridContainer';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';
import {PROJECT_VIEW_TABS} from '../../constants/navigation';
import i18n from '../../utils/i18n';
import {COLLECTION_TYPES} from '../../constants/issue-query-params';
import {preloadedFilterQueryParamsState} from '../../constants/preloaded-states';
import {viewTypes} from '../../constants/view-types';
import ProjectSetupInProgressPlaceholder from '../common/ProjectSetupInProgressPlaceholder';

class ProjectView extends PureComponent {
  componentWillMount() {
    //MixPanel Event - when user watch issue screen and what screen is it (Project/document)
    this.props.trackEvent(entityIssueScreen(screenType.PROJECT));
  }

  handleTabChange = tab => {
    const newRoute =
      tab.id === PROJECT_VIEW_TABS.TEMPLATES
        ? `project/${TYPE_QUALITY_ISSUES}/templates`
        : `project/${TYPE_QUALITY_ISSUES}`;
    const collectionType = tab.id === PROJECT_VIEW_TABS.TEMPLATES ? COLLECTION_TYPES.TEMPLATES : TYPE_QUALITY_ISSUES;
    this.props.setQueryParamsAction(preloadedFilterQueryParamsState[viewTypes.PROJECT][collectionType], collectionType);
    this.props.changeLocationAction(newRoute);
  };

  renderSelectedTab() {
    const {selectedTabId} = this.props;
    return selectedTabId === PROJECT_VIEW_TABS.TEMPLATES ? <TemplatesProjectGridContainer /> : <ProjectGrid />;
  }

  render() {
    const {
      isLoadingCurrentUserPermissions,
      isTemplatesViewEnabled,
      shouldShowProjectSetupInProgressPlaceholder
    } = this.props;
    if (isLoadingCurrentUserPermissions) {
      return <Loader />;
    }
    if (shouldShowProjectSetupInProgressPlaceholder) {
      return <ProjectSetupInProgressPlaceholder />;
    }
    if (isTemplatesViewEnabled) {
      return (
        <div className="ProjectView">
          <Tabs
            className="ProjectView__navigation-tabs"
            tabs={ProjectView.tabs}
            selectedTab={ProjectView.tabs.find(nav => this.props.selectedTabId === nav.id)}
            onTabChange={this.handleTabChange}
            theme={Tabs.Themes.admin}
          />
          {this.renderSelectedTab()}
        </div>
      );
    } else {
      return <ProjectGrid />;
    }
  }
}

ProjectView.tabs = [
  {
    id: PROJECT_VIEW_TABS.ISSUES,
    name: () => i18n.t('projectView.tabs.issues')
  },
  {
    id: PROJECT_VIEW_TABS.TEMPLATES,
    name: () => i18n.t('projectView.tabs.templates')
  }
];

ProjectView.displayName = 'ProjectView';

ProjectView.defaultProps = {
  selectedTabId: PROJECT_VIEW_TABS.ISSUES
};

ProjectView.propTypes = {
  selectedTabId: PropTypes.string,
  isLoadingCurrentUserPermissions: PropTypes.bool.isRequired,
  isTemplatesViewEnabled: PropTypes.bool.isRequired,
  trackEvent: PropTypes.func.isRequired,
  setQueryParamsAction: PropTypes.func.isRequired,
  changeLocationAction: PropTypes.func.isRequired,
  shouldShowProjectSetupInProgressPlaceholder: PropTypes.bool.isRequired
};

export default ProjectView;
